import {Component, Input} from '@angular/core';
import {Proposal} from '../../../model/proposal/proposal';
import {UploadLocation} from '../../../enum/upload-location';
import {BinaryData} from '../../../model/proposal/binary-data';

@Component({
    selector: 'app-proposal-details-download',
    templateUrl: './proposal-details-download.component.html',
    styleUrls: ['./proposal-details-download.component.scss'],
    standalone: false
})
export class ProposalDetailsDownloadComponent {
  @Input() set proposal(proposal: Proposal) {
    for (let file of proposal.proposalInformation.attachedFiles) {
      if (this.mappedAttachedFiles.get(file.uploadLocation) == null) {
        this.mappedAttachedFiles.set(file.uploadLocation, [file]);
      } else {
        this.mappedAttachedFiles.get(file.uploadLocation).push(file);
      }
    }
  }


  mappedAttachedFiles = new Map<UploadLocation, BinaryData[]>();


  mapUploadLocation(uploadLocation: UploadLocation) {
    switch (uploadLocation) {
      case UploadLocation.PREVIOUSDAMAGE:
        return 'previousDamages';
      case UploadLocation.INDIVIDUALCLAUSESCONDITIONS:
        return 'individualClausesConditions';
      case UploadLocation.PROPOSALINFORMATION:
        return 'proposalInformation';
      case UploadLocation.RISKDESCRIPTION:
        return 'riskDescription';
      case UploadLocation.RISKLOCATION:
        return 'riskLocation';
    }
  }

}
